import { useQuery } from '@tanstack/react-query'
import { useApi } from '../store/auth.store'

interface Area {
  id: string
  name: string
  description?: string
  email?: string
}

export function useAreas() {
  const api = useApi()
  return useQuery<Area[]>({
    queryKey: ['areas'],
    queryFn: () => api.get<Area[]>('/areas'),
    staleTime: 300_000,
  })
}
